import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export function getProgramTypes() {
    return http.get(API_PATHS.listProgramTypes);
}
